<!-- Home.vue -->
<template>
  <div class="preloader-area" :show="displayLoader">
    <div class="preloader__image"></div>
  </div>

  <HomeBanner />

  <!--News, Notices, Event Area Start-->
  <div class="eduction-area pb-70" style="display: none;">
    <div class="container-fluid p-0">
      <div class="row g-0">
        <div class="col-lg-3 col-md-6" data-aos-duration="1200" data-aos-delay="200" data-aos-once="true">
          <a href="https://rdc.eshala.co.in/page/notices">
            <div class="single-education-card bg-1">
              <div class="edication-content">
                <div class="icon">
                  <i class="flaticon-messenger"></i>
                </div>

                <h3>Important Notices</h3>
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-3 col-md-6" data-aos-duration="1200" data-aos-delay="400" data-aos-once="true">
          <a href="https://rdc.eshala.co.in/events">
            <div class="single-education-card bg-2">
              <div class="edication-content">
                <div class="icon">
                  <i class="flaticon-advertising"></i>
                </div>

                <h3>Upcoming Events</h3>
              </div>
            </div>
          </a>
        </div>

        <div class="col-lg-3 col-md-6" data-aos-duration="1200" data-aos-delay="600" data-aos-once="true">
          <a href="https://rdc.eshala.co.in/page/news">
            <div class="single-education-card bg-3">
              <div class="edication-content">
                <div class="icon">
                  <i class="flaticon-clock"></i>
                </div>
                <h3>Latest News</h3>
              </div>
            </div>
          </a>
        </div>

        <div class="col-lg-3 col-md-6" data-aos-duration="1200" data-aos-delay="800" data-aos-once="true">
          <router-link to="/achievements">
            <div class="single-education-card bg-4">
              <div class="edication-content">
                <div class="icon">
                  <i class="flaticon-athletics"></i>
                </div>
                <h3>Achievements</h3>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <!--News, Notices, Event Area End-->

  <!--Start Campus Information-->
  <div class="campus-information-area pb-70">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="campus-image">
            <img src="/vf/images/home/institute.png" alt="Image" />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="campus-content style-2">
            <div class="campus-title">
              <h2>
                Welcome to <br />
                Vedanta P.G. Girls College
              </h2>
              <p>
                At Vedanta Post Graduate Girls College, education knows no
                bounds and dreams find wings to soar. The college strives to
                empower women and embolden their voices. The college offers
                undergraduate as well as postgraduate courses in the streams of
                Arts, Science, and Commerce. Along with providing quality
                education, Vedanta P.G Ringus college does the complementary
                action of spurring each student to discover their latent
                potential.
              </p>
            </div>
            <div class="list">
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <ul>
                    <li>
                      <i class="ri-check-fill"></i>
                      <p>A Not-for-Profit Institution</p>
                    </li>
                    <li>
                      <i class="ri-check-fill"></i>
                      <p>Subsidised Fees</p>
                    </li>
                    <li>
                      <i class="ri-check-fill"></i>
                      <p>Learn from the Best</p>
                    </li>
                  </ul>
                </div>
                <div class="col-lg-6 col-md-6">
                  <ul>
                    <li>
                      <i class="ri-check-fill"></i>
                      <p>Certification Courses</p>
                    </li>
                    <li>
                      <i class="ri-check-fill"></i>
                      <p>Seminars and Workshop</p>
                    </li>
                    <li>
                      <i class="ri-check-fill"></i>
                      <p>Industry Connect</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="counter">
              <div class="row">
                <div class="col-lg-4 col-4">
                  <div class="counter-card">
                    <h1>
                      <span class="odometer" data-count="30">30</span>
                      <span class="target">+</span>
                    </h1>
                    <p>Affiliated Courses</p>
                  </div>
                </div>
                <div class="col-lg-4 col-4">
                  <div class="counter-card">
                    <h1>
                      <span class="odometer" data-count="30">30</span>
                      <span class="target heading-color">k</span><span class="target">+</span>
                    </h1>
                    <p>Student Graduates</p>
                  </div>
                </div>
                <div class="col-lg-4 col-4">
                  <div class="counter-card">
                    <h1>
                      <span class="odometer" data-count="30">30</span>
                      <span class="target">+</span>
                    </h1>
                    <p>Years of Experience</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <router-link to="/applynow" class="default-btn btn"
              >Start your application<i class="flaticon-next"></i
            ></router-link> -->
            <a href="https://rdc.eshala.co.in/page/enquiry" class="default-btn btn">Start your application<i
                class="flaticon-next"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--End Campus Information-->


  <!--Start Events Area-->
  <div class="events-area bg-f4f6f9 ptb-50">
    <div class="container">
      <div class="section-title">
        <h2>Latest Events</h2>
        <p>Stay updated on the latest happenings, celebrations, and exclusive events at VPGGC</p>
      </div>
      <div class="row justify-content-center">

        <div class="col-lg-3 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200"
          data-aos-delay="200" data-aos-once="true" v-for="(item, index) in latestEvents" :key="index">

          <div class="single-events-card">
            <div class="events-image">
              <a @click.prevent="displayEventDetails(item.id)" style="font-size: 12px;cursor: pointer;"> <img
                  :src="formatImage(item.event_thumbnail_pic_path)" alt="Image" /></a>
              <div class="date" style="padding: 10px;margin-bottom: 10px;">
                <span>{{ formatDate(item.start_date) }}</span>
              </div>
            </div>
            <div class="events-content">
              <div class="admin">
                <p><a @click.prevent="displayEventDetails(item.id)" style="font-size: 12px;cursor: pointer;"><i
                      class="flaticon-student-with-graduation-cap"></i>{{
                        item.event_category_name }}</a>
                </p>
              </div>
              <a @click.prevent="displayEventDetails(item.id)" style="font-size: 12px;cursor: pointer;">
                <h5>{{ truncateTitle(item.event_title, 5) }}</h5>
              </a>
            </div>
          </div>

        </div>

        <!-- <div class="col-lg-3 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200"
          data-aos-delay="200" data-aos-once="true">
          <div class="single-events-card">
            <div class="events-image">
              <a href="#"><img src="images/events/event_320_250_1.png" alt="Image"></a>
              <div class="date">
                <span>27</span>
                <p>May</p>
              </div>
            </div>
            <div class="events-content">
              <div class="admin">
                <p><a href="#" style="font-size: 12px;"><i class="flaticon-student-with-graduation-cap"></i>Seminar and
                    Workshops</a>
                </p>
              </div>
              <a href="#">
                <h5>Yuva Rojgar Mela</h5>
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200"
          data-aos-delay="400" data-aos-once="true">
          <div class="single-events-card">
            <div class="events-image">
              <a href="#"><img src="images/events/event_320_250_2.png" alt="Image"></a>
              <div class="date">
                <span>05</span>
                <p>May</p>
              </div>
            </div>
            <div class="events-content">
              <div class="admin">
                <p><a href="#" style="font-size: 12px;"><i class="flaticon-student-with-graduation-cap"></i>Seminar and
                    Workshops</a>
                </p>
              </div>
              <a href="#">
                <h5>5-day Faculty Development ...</h5>
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200"
          data-aos-delay="600" data-aos-once="true">
          <div class="single-events-card">
            <div class="events-image">
              <a href="#"><img src="images/events/event_320_250_3.png" alt="Image"></a>
              <div class="date">
                <span>05</span>
                <p>Apr</p>
              </div>
            </div>
            <div class="events-content">
              <div class="admin">
                <p><a href="#" style="font-size: 12px;"><i class="flaticon-student-with-graduation-cap"></i>Awareness
                    Program </a>
                </p>
              </div>
              <a href="#">
                <h5>Civil Defiance Mock Drill</h5>
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200"
          data-aos-delay="600" data-aos-once="true">
          <div class="single-events-card">
            <div class="events-image">
              <a href="#"><img src="images/events/event_320_250_4.png" alt="Image"></a>
              <div class="date">
                <span>28</span>
                <p>Mar</p>
              </div>
            </div>
            <div class="events-content">
              <div class="admin">
                <p><a href="#" style="font-size: 12px;"><i class="flaticon-student-with-graduation-cap"></i>Seminar and
                    Workshops </a>
                </p>
              </div>
              <a href="#">
                <h5>Free Vocational Skill Development </h5>
              </a>
            </div>
          </div>
        </div> -->
      </div>
      <div class="more-health-care text-center">
        <p> <a href="https://rdc.eshala.co.in/events" class="read-more-btn active">More on Events<i
              class="flaticon-next"></i></a></p>
      </div>
    </div>
  </div>
  <!--End Events Area-->

  <!-- feature Info -->
  <div>
    <section class="steps-area p-relative" style="background-color: #111d5e; display: block">
      <div class="animations-10">
        <img src="/images/an-img-10.png" alt="an-img-01" />
      </div>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="section-title_2 mb-35 mt-35 wow fadeInDown animated" data-animation="fadeInDown"
              data-delay=".4s" style="visibility: visible; animation-name: fadeInDown">
              <h2 style="font-size: 42px">Best Features</h2>
              <p>Discover Distinctive Advantages at Vedanta College</p>
            </div>
            <ul class="pr-20 pb-20">
              <li>
                <div class="step-box wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s"
                  style="visibility: visible; animation-name: fadeInUp">
                  <div class="dnumber">
                    <div class="date-box">1</div>
                  </div>
                  <div class="text">
                    <h3>Affordable Fees</h3>
                    <p>Learn at a Subsidized Fees and Fuel Your Dreams</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="step-box wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s"
                  style="visibility: visible; animation-name: fadeInUp">
                  <div class="dnumber">
                    <div class="date-box">2</div>
                  </div>
                  <div class="text">
                    <h3>Learn beyond classrooms</h3>
                    <p>
                      Expand Your Horizons with Add-on Courses and Engaging
                      Workshop
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="step-box wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s"
                  style="visibility: visible; animation-name: fadeInUp">
                  <div class="dnumber">
                    <div class="date-box">3</div>
                  </div>
                  <div class="text">
                    <h3>Industry Connect</h3>
                    <p>
                      Experience Real-World Learning with Industry Field Visit
                    </p>
                  </div>
                </div>
              </li>

              <li>
                <div class="step-box wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s"
                  style="visibility: visible; animation-name: fadeInUp">
                  <div class="dnumber">
                    <div class="date-box">4</div>
                  </div>
                  <div class="text">
                    <h3>Skill Enhancement</h3>
                    <p>
                      Unleash your potential with exceptional skill enhancement
                      initiatives
                    </p>
                  </div>
                </div>
              </li>

              <li>
                <div class="step-box wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s"
                  style="visibility: visible; animation-name: fadeInUp">
                  <div class="dnumber">
                    <div class="date-box">5</div>
                  </div>
                  <div class="text">
                    <h3>Hostel Accomodation</h3>
                    <p>
                      Enjoy the convenience of comfortable hostel accommodation
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-lg-6 col-md-12">
            <div class="step-imgx wow fadeInLeft animated image-container" data-animation="fadeInLeft" data-delay=".4s"
              style="visibility: visible; animation-name: fadeInLeft"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- feature Info -->

  <!-- news / notices start -->
  <div class="alumni-area pt-70 pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="alumni-left-content">
            <h3>Latest News</h3>
            <div id="nav-curriculum" role="tabpanel" aria-labelledby="nav-curriculum-tab">
              <div class="curriculum">
                <div class="curriculum-list latest_news">
                  <ul>
                    <li v-for="(item, index) in latestNews" :key="index">
                      <a @click.prevent="openUrl(item.slug)" style="cursor: pointer;">
                        {{ truncateTitle(item.title, 10) }}
                      </a>
                      <span>{{ formatDate(item.date) }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="more-health-care text-center">
              <p> <a href="https://rdc.eshala.co.in/page/news" class="read-more-btn active">More on News<i
                    class="flaticon-next"></i></a>
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="alumni-right-content">
            <h3>Latest Notices</h3>
            <div id="nav-curriculum" role="tabpanel" aria-labelledby="nav-curriculum-tab">
              <div class="curriculum">
                <div class="curriculum-list latest_notices">
                  <ul>
                    <li v-for="(item, index) in latestNotices" :key="index">
                      <a @click.prevent="openUrl(item.slug)" style="cursor: pointer;">
                        {{ truncateTitle(item.title, 20) }}
                      </a>
                      <span>{{ formatDate(item.date) }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="more-health-care text-center">
              <p> <a href="https://rdc.eshala.co.in/page/notices" class="read-more-btn active">More on Notices<i
                    class="flaticon-next"></i></a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- news / notices end -->


  <!--Start Department Area-->
  <div class="courses-area pt-70 pb-70 bg-f4f6f9">
    <div class="container">
      <div class="section-title">
        <h2>Departments</h2>
        <p>
          Providing a wide array of UG/PG programs to suit your academic goals.
        </p>
      </div>
      <carousal-comp-type-one :content-info="deptInfo" />
    </div>
  </div>
  <!--End Department Area-->

  <!-- Other courses start -->

  <!-- Other courese end -->

  <!-- Campus start -->
  <div class="campus-life-area ptb-100">
    <div class="container">
      <div class="section-title">
        <h2>The Campus</h2>
        <p>
          Nestled in the Heart of Reengus, Vedanta PG College's Campus: Your
          Gateway to Educational Excellence.
        </p>
      </div>
      <div class="campus-slider2">
        <carousal-comp-type-two :content-info="campusInfo" />
      </div>
    </div>
  </div>
  <!-- Campus end -->

  <!--Start Video  Area-->
  <div class="admisssion-area ptb-100 admission-bg">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-6">
          <div class="admission-left-content">
            <h2>Your Learning Starts Today!</h2>
            <p>
              We believe that a well-rounded education is essential, and offer
              our students the opportunity to get involved in a variety of
              activities that interest them.
            </p>
            <!-- <router-link  to="/applynow" class="default-btn btn"
              >Enroll Today and Embrace Success<i class="flaticon-next"></i
            ></router-link> -->
            <a href="https://rdc.eshala.co.in/page/enquiry" class="default-btn btn">Enroll Today and Embrace Success<i
                class="flaticon-next"></i></a>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="admission-right-content">
            <ul>
              <li>
                <p>Watch the initiatives of <br />Vedanta Foundation</p>
              </li>
              <li>
                <div class="icon">
                  <a class="popup-youtube play-btn" href="https://www.youtube.com/watch?v=7uwKoiaZRf0"><i
                      class="ri-play-fill"></i></a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--End Video Area-->

  <!--Start Student Life Area-->
  <div class="student-life-area pt-70 pb-70">
    <div class="container">
      <div class="section-title">
        <h2>Student Life @ Vedanta P.G. College</h2>
        <p>Where Learning and Lifelong Memories Unite.</p>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="student-life-card">
            <img src="/vf/images/home/SL1.png" alt="Image" />
            <div class="tags">
              <p>Experiential Learning</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="student-life-card">
            <img src="/vf/images/home/SL2.png" alt="Image" />
            <div class="tags">
              <p>Industry Visit</p>
            </div>
          </div>
          <div class="student-life-card">
            <img src="/vf/images/home/SL3.png" alt="Image" />
            <div class="tags">
              <p>Seminars & Workshops</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--End Student Life Area-->

  <!-- Achievements/Alumni start -->
  <div class="alumni-area pt-70 pb-70 bg-f4f6f9">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="alumni-left-content">
            <h3>Our Achievements</h3>
            <div class="single-alumni-events-card">
              <div class="row align-items-center">
                <div class="col-lg-5 col-md-5">
                  <div class="alumni-img">
                    <img src="vf/images/student_corner/alumni/1.png" alt="Image" style="height: 200px;width: 200px;">
                  </div>
                </div>
                <div class="col-lg-7 col-md-7">
                  <div class="alumni-content">
                    <h3>Maya Yogi</h3>
                    <div class="location">
                      <p><i class="ri-medal-2-fill"></i><strong></strong>Selected for Indian Volleyball Team</p>
                    </div>
                    <div class="location">
                      <p><i class="ri-graduation-cap-line"></i><strong></strong>B.A.</p>
                    </div>
                    <div class="time">
                      <p><i class="flaticon-time"></i><strong></strong>2024-25</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="single-alumni-events-card">
              <div class="row align-items-center">
                <div class="col-lg-5 col-md-5">
                  <div class="alumni-img">
                    <img src="vf/images/student_corner/alumni/2.png" alt="Image" style="height: 200px;width: 200px;">
                  </div>
                </div>
                <div class="col-lg-7 col-md-7">
                  <div class="alumni-content">
                    <h3>Kumkum Rathore</h3>
                    <div class="location">
                      <p><i class="ri-medal-2-fill"></i><strong></strong>Participated National Shooting Championship
                        Delhi 2024</p>
                    </div>
                    <div class="location">
                      <p><i class="ri-graduation-cap-line"></i><strong></strong>M.A. Public Administration</p>
                    </div>
                    <div class="time">
                      <p><i class="flaticon-time"></i><strong></strong>2024-25</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="single-alumni-events-card">
              <div class="row align-items-center">
                <div class="col-lg-5 col-md-5">
                  <div class="alumni-img">
                    <img src="vf/images/student_corner/alumni/3.png" alt="Image" style="height: 200px;width: 200px;">
                  </div>
                </div>
                <div class="col-lg-7 col-md-7">
                  <div class="alumni-content">
                    <h3>Nikita Nirmal</h3>
                    <div class="location">
                      <p><i class="ri-medal-2-fill"></i><strong></strong>NET JRF December 2025</p>
                    </div>
                    <div class="location">
                      <p><i class="ri-graduation-cap-line"></i><strong></strong> M.Sc. Physics</p>
                    </div>
                    <div class="time">
                      <p><i class="flaticon-time"></i><strong></strong>2024-25</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="more-health-care text-center">
              <p> <router-link to="/achievements" class="read-more-btn active">More on Achievements<i
                    class="flaticon-next"></i></router-link></p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="alumni-right-content">
            <h3>Our Alumni</h3>
            <div class="single-alumni-events-card">
              <div class="row align-items-center">
                <div class="col-lg-5 col-md-5">
                  <div class="alumni-img">
                    <img src="vf/images/student_corner/alumni/4.png" alt="Image" style="height: 200px;width: 200px;">
                  </div>
                </div>
                <div class="col-lg-7 col-md-7">
                  <div class="alumni-content">
                    <h3>Kavita Jangir</h3>
                    <div class="location">
                      <p><i class="ri-medal-2-fill"></i><strong></strong>Quality Control Department HZL Kayad Mines</p>
                    </div>
                    <div class="location">
                      <p><i class="ri-graduation-cap-line"></i><strong></strong>B.Sc.</p>
                    </div>
                    <div class="time">
                      <p><i class="flaticon-time"></i><strong></strong>2023-24</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="single-alumni-events-card">
              <div class="row align-items-center">
                <div class="col-lg-5 col-md-5">
                  <div class="alumni-img">
                    <img src="vf/images/student_corner/alumni/5.png" alt="Image" style="height: 200px;width: 200px;">
                  </div>
                </div>
                <div class="col-lg-7 col-md-7">
                  <div class="alumni-content">
                    <h3>Ayushi Kumawat</h3>
                    <div class="location">
                      <p><i class="ri-medal-2-fill"></i><strong></strong>School Lecturer Level-2</p>
                    </div>
                    <div class="location">
                      <p><i class="ri-graduation-cap-line"></i><strong></strong>M.A. English Literature</p>
                    </div>
                    <div class="time">
                      <p><i class="flaticon-time"></i><strong></strong>2022-23</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="single-alumni-events-card">
              <div class="row align-items-center">
                <div class="col-lg-5 col-md-5">
                  <div class="alumni-img">
                    <img src="vf/images/student_corner/alumni/6.png" alt="Image" style="height: 200px;width: 200px;">
                  </div>
                </div>
                <div class="col-lg-7 col-md-7">
                  <div class="alumni-content">
                    <h3> Priyanka Gangawat</h3>
                    <div class="location">
                      <p><i class="ri-medal-2-fill"></i><strong></strong>School Lecturer</p>
                    </div>
                    <div class="location">
                      <p><i class="ri-graduation-cap-line"></i><strong></strong>M.A. English Literature</p>
                    </div>
                    <div class="time">
                      <p><i class="flaticon-time"></i><strong></strong>2013-14</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="more-health-care text-center">
              <p> <router-link to="/alumni" class="read-more-btn active">More on Alumni<i class="flaticon-next"></i></router-link></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Achievements/Alumni end -->


  <!--Start Check Student Stories-->
  <div class="students-stories-area pt-70 pb-70">
    <div class="container">
      <div class="section-title">
        <h2>Check Our stories</h2>
        <p>
          Where Excellence Meets Inspiration: Discover Success Stories at
          Vedanta PG Girls' College
        </p>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 aos-init aos-animate" data-aos-duration="1200" data-aos-delay="200"
          data-aos-once="true">
          <div class="single-stories-card style2">
            <div class="stories-content">
              <h3>Neetu Dhayal | Gold Medalists</h3>
            </div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/rh3DUdEG7MU"
              title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 aos-init aos-animate" data-aos-duration="1200" data-aos-delay="400"
          data-aos-once="true">
          <div class="single-stories-card style2">
            <div class="stories-content">
              <h3>Ritu Dhayal | Volleyball Champ</h3>
            </div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/-pfKyFdGF7c"
              title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 aos-init aos-animate" data-aos-duration="1200" data-aos-delay="600"
          data-aos-once="true">
          <div class="single-stories-card style2">
            <div class="stories-content">
              <h3>Maya | Volleyball Champ</h3>
            </div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/j_4f8fuWDI8"
              title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <!-- Test1 -->
        <div class="col-lg-4 col-md-6 aos-init aos-animate" data-aos-duration="1200" data-aos-delay="600"
          data-aos-once="true">
          <div class="single-stories-card style2">
            <div class="stories-content">
              <div class="comments">
                <div class="single-comments-box">
                  <img src="/vf/images/home/T3.png" alt="Images" />
                  <h4>Beeru – Women & Child Development Officer, Jhotwara, Jaipur</h4>
                </div>
                <p>
                  My journey from student to government officer was rooted in the values and education I received at
                  Vedanta PG Girls’ College. The faculty’s mentorship and the college’s focus on leadership and personal
                  development laid the foundation for my success in public service.
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Test2 -->
        <div class="col-lg-4 col-md-6 aos-init aos-animate" data-aos-duration="1200" data-aos-delay="600"
          data-aos-once="true">
          <div class="single-stories-card style2">
            <div class="stories-content">
              <div class="comments">
                <div class="single-comments-box">
                  <img src="/vf/images/home/T2.png" alt="Images" />
                  <h4>Indra Dhayal – School Lecturer</h4>
                </div>
                <p>
                  Vedanta PG Girls’ College gave wings to my dreams. The institution’s strong academic foundation and
                  unwavering support from faculty helped me crack one of the most competitive exams in the country. I
                  owe my success to the college that taught me discipline, determination, and dedication.
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Test3 -->
        <div class="col-lg-4 col-md-6 aos-init aos-animate" data-aos-duration="1200" data-aos-delay="600"
          data-aos-once="true">
          <div class="single-stories-card style2">
            <div class="stories-content">
              <div class="comments">
                <div class="single-comments-box">
                  <img src="/vf/images/home/T1.png" alt="Images" />
                  <h4>Ms. Priyanka Gangawat – Senior Teacher, English</h4>
                </div>
                <p>
                  The environment at Vedanta PG Girls’ College nurtured my love for literature and teaching. The
                  encouragement from professors and the vibrant academic culture empowered me to become a confident
                  educator. My career began here—and I’m forever grateful.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--End Check Student Stories-->

  <!--  Start Collaboration Area -->
  <div>
    <div class="section-title">
      <h3>Top Collaborations and Partners</h3>
      <p>Elevating Futures, Empowering Careers</p>
    </div>
    <div class="brand-area pt-30 pb-30">
      <div class="container">
        <div class="recruiter mb-20">
          <carousal-comp-type-three :content-info="recruiterInfo" />
        </div>
      </div>
    </div>
  </div>
  <!--  End Collaboration Area -->

  <!-- Start Modal -->
  <div class="card flex justify-content-center">
    <Dialog v-model:visible="visible" header="Admission Started!!" modal>
      <img src="/vf/images/popup_banner_1.png" />

      <div class="flex justify-content-end gap-2">
        <div class="interview" style="text-align: center">
          <a href="https://rdc.eshala.co.in/page/enquiry" class="default-btn btn" style="margin: 1rem">Enquire Now</a>
        </div>
      </div>
    </Dialog>
  </div>

  <!-- Modal End -->
</template>

<script>
import HomeBanner from "@/components/HomeBanner";
import CarousalCompTypeOne from "@/components/CarousalCompTypeOne.vue";
import CarousalCompTypeTwo from "@/components/CarousalCompTypeTwo.vue";
import CarousalCompTypeThree from "@/components/CarousalCompTypeThree.vue";
import Dialog from "primevue/dialog";
import { BASE_URL } from '@/url_config';

export default {
  name: "HomePage",
  components: {
    HomeBanner,
    CarousalCompTypeOne,
    CarousalCompTypeTwo,
    CarousalCompTypeThree,
    Dialog,
  },
  data() {
    return {
      displayLoader: true,
      visible: true,
      latestNews: [],
      latestNotices: [],
      latestEvents: [],
      deptInfo: [
        {
          name: "Department of Humanities",
          image: "/vf/images/home/D1.png",
          url: "/artsdepartment",
          description:
            "Department of Humanities offers a diverse range of graduate and undergraduate courses in English and Hindi literature, fine arts, geography, and political science.",
        },
        {
          name: "Department of Commerce",
          image: "/vf/images/home/D2.png",
          url: "/commercedepartment",
          description:
            "Department of Commerce offers exciting opportunities in finance, human resources, marketing, and more. Elevate your career and knowledge in the world of commerce with us.",
        },
        {
          name: "Department of Science",
          image: "/vf/images/home/D3.png",
          url: "/sciencedepartment",
          description:
            "Department of Science provides an enriching and stimulating environment for students pursuing graduate and post graduate courses in Botany, Chemistry, Maths, and Biology.",
        },
      ],
      campusInfo: [
        {
          title: "Smart Classrooms",
          image: "/vf/images/home/C1.png",
          url: "#",
          subtitle: "Education through digital pedagogy",
        },
        {
          title: "Library",
          image: "/vf/images/home/C2.png",
          url: "#",
          subtitle: "Explore a world of knowledge",
        },
        {
          title: "Hostel Facilities",
          image: "/vf/images/home/C3.png",
          url: "#",
          subtitle: "Modern & State-of-the-art Hostel",
        },
        {
          title: "Sports and Fitness",
          image: "/vf/images/home/C5.png",
          url: "#",
          subtitle: "Health with academic excellence",
        },
        {
          title: "Science Laboratories",
          image: "/vf/images/home/C6.png",
          url: "#",
          subtitle: "Lab fueling curiosity and innovation",
        },
        {
          title: "IT Laboratory",
          image: "/vf/images/home/C7.png",
          url: "#",
          subtitle: "Experience cutting-edge Technology",
        },
      ],
      recruiterInfo: [
        {
          image: "/vf/images/home/partners/j1.png",
        },
        {
          image: "/vf/images/home/partners/j2.png",
        },
        {
          image: "/vf/images/home/partners/j3.png",
        },
        {
          image: "/vf/images/home/partners/j4.png",
        },
        {
          image: "/vf/images/home/partners/j5.png",
        },
      ],
    };
  },
  mounted() {
    this.displayLoader = false;
  },

  methods: {
    // Fetch the data from the API using fetch
    fetchLatest(typeValue) {
      fetch(`${BASE_URL}/api/webservice/getLatestDetailsForSite?type=` + typeValue)  // Replace with your actual API URL
        .then(response => response.json())
        .then((data) => {
          if (typeValue == 'news') {
            this.latestNews = data.latestInfo;
          } else {
            this.latestNotices = data.latestInfo;
          }

        })
        .catch((error) => {
          console.error('There was an error fetching the data:', error);
          // this.loading = false;
        });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';  // If no date is available, return an empty string

      const date = new Date(dateStr); // Create a Date object from the string

      // Get the day, month, and year
      const day = ("0" + date.getDate()).slice(-2);  // Ensure 2 digits
      const month = ("0" + (date.getMonth() + 1)).slice(-2); // Get the month, add 1 (months are 0-indexed)
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;  // Return the formatted date in dd-mm-yyyy format
    },
    truncateTitle(title, length) {
      if (!title) return ''; // Return an empty string if title is empty or null

      const words = title.split(" ");  // Split the title into words

      if (words.length > length) {
        return words.slice(0, length).join(" ") + "...";
      }

      return title;
    },
    openUrl(slug) {
      const url = `${BASE_URL}/read/${slug}`;
      window.open(url, '_blank'); // Open the URL in a new tab
    },
    displayEventDetails(event_id) {
      const url = `${BASE_URL}/events/eventdetail/${event_id}`;
      window.open(url, '_blank'); // Open the URL in a new tab
    },
    fetchLatestEvents() {
      fetch(`${BASE_URL}/api/webservice/getLatestEventsForSite`)
        .then(response => response.json())
        .then((data) => {

          this.latestEvents = data.latestInfo;

        })
        .catch((error) => {
          console.error('There was an error fetching the data:', error);
          // this.loading = false;
        });
    },
    formatImage(imageVal) {

      return `${BASE_URL}/` + imageVal;

    }
  },
  created() {
    // Fetch data when the component is created
    this.fetchLatest('news');
    this.fetchLatest('notices');
    this.fetchLatestEvents();
  }
};
</script>
